import script from "./simple-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./simple-button.vue?vue&type=script&lang=ts&setup=true"

import "./simple-button.vue?vue&type=style&index=0&id=35553178&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35553178"]])

export default __exports__